export type SMSPopupInfo = {
    isFirstBoxShipped: boolean;
    countryCode: string;
    serviceName: string;
    isSMSServiceEnabled: boolean;
    optInPopupSeen: boolean;
    hideSMS: boolean;
    showSmsPopup: boolean;
    showThanksPopup: boolean;
    phoneNumber?: string;
};

export type SMSInputValidationInfo = {
    validUSAreaCode?: number[];
    isRedBackground: boolean;
    isNumberError?: boolean;
    isAreaCodeError?: boolean;
    isPhoneNumError?: boolean;
    isAPIError?: boolean;
};

export type payloadInfo = {
    optInPopupSeen: boolean;
    optedIn: boolean;
    phoneNumber: string;
    namespaceId: string;
    optedInSMSSentDateTime?: null;
};

export enum countryPhoneCode {
    UK = '44',
    US = '1'
}

export const numbers = /^[0-9]+$/;
export const validUSPhoneNum = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
